

function tooltipText(result) 
{
    //console.log(result);
    result = result.split(",");
    var resultString = "<div><font size=2>T<font size=1 >p</font> =  &nbsp;95 godina: a<font size=1  style='vertical-align:sub;'>gR</font> = ";
    resultString += parseFloat(result[0]).toFixed(3);
    resultString += " g<br>T<font size=1 >p</font> = 225 godina: a<font size=1 style='vertical-align:sub;'>gR</font> = ";
    resultString += parseFloat(result[1]).toFixed(3);
    resultString += " g<br>T<font size=1 >p</font> = 475 godina: a<font size=1 style='vertical-align:sub;'>gR</font> = ";
    resultString += parseFloat(result[2]).toFixed(3);
    resultString += " g</font></div>";
    return resultString;
}

function izracunaj(x,y)
{
    //x = 19.127255985267;
    //y = 44.918322794118;
    //console.log(x);
    //console.log(y);
    var dataMin = {"xmin" : 13.0, "xdelta" : 0.012149109999999297, "ymin" : 42.0, "ydelta" : 0.008999899999999172};
    var xx = zaokruzi( dataMin["xmin"], dataMin["xdelta"],decimale(x));
    var yy = zaokruzi( dataMin["ymin"], dataMin["ydelta"],decimale(y));
    document.getElementById("desc2").innerHTML="<b>Izracunati x:</b> "+xx+"&nbsp;&nbsp;&nbsp;<b>Izracunati y:</b> "+yy;

    $.get('getData.php', { x: xx, y: yy }).done(function(data, status) {
        console.log(status);
        if (status == "success") {
            var element = document.getElementById("popup");
            var result = String(tooltipText(data));
            $(element).popover('dispose');
            $(element).popover({
            container: element,
            placement: 'top',
            animation: false,
            html: true,
            sanitize: false,
            content: String(result),
            });
            
            $(element).popover('show');
        }
    });
}

function zaokruzi(poc,delta,z)
{
    var razlika = z-poc;
    var pozicija = Math.round(razlika/delta);
    var ret = decimale(poc+(pozicija*delta));
    return ret;
}

function isNum(id
    ){
    var elem = document.getElementById(id);
    if(elem == null) return 0;
    var str = elem.value;
    str = str.replace(",",".");
    elem.value=str;
    return str;
}

function decimale(str)
{
    return Math.round(str*100000000)/100000000;
}

function update(xy,promjena,saKarte)
{
    console.log(promjena);

    var val1 = isNum(xy+"_sekunda"+promjena)/60;
    val1 = (val1 + isNum(xy+"_minuta"+promjena)) / 60;
    val1 += isNum(xy+"_stupanj"+promjena);

    var stupnjevi = parseInt(val1);
    var minuteDecimal = decimale((val1-stupnjevi)*60);
    var minuteCijele = parseInt((val1-stupnjevi)*60);
    var sekunde = decimale((minuteDecimal-minuteCijele)*60);
    var stupnjeviDecimal = decimale(stupnjevi+(minuteCijele/60)+(sekunde/60/60));

    if (promjena != 1 || saKarte) {
        document.getElementById(xy+"_stupanj1").value=stupnjeviDecimal;
    }

    if (promjena != 2){
        document.getElementById(xy+"_stupanj2").value=stupnjevi;
        document.getElementById(xy+"_minuta2").value=minuteDecimal;
    }

    if (promjena != 3){
        document.getElementById(xy+"_stupanj3").value=stupnjevi;
        document.getElementById(xy+"_minuta3").value=minuteCijele;
        document.getElementById(xy+"_sekunda3").value=sekunde;
    }
}

export { izracunaj, update };
